import React from 'react';
import {Route} from 'react-router-dom';
import {UserChatter} from "./resources/users";

export default [
    <Route exact path="/chatter" component={UserChatter}/>,
];
